import Medias from '../components/Medias'
import Performances from '../components/Performances'

function Home({ t, lang }) {
  return (
    <main className="page-container bg-custom">
        <div className='container text-center'>
            <h1 className='page-title'>{t("nav_medias").toUpperCase()}</h1>
            <Medias t={t} lang={lang} />
        </div>
    </main>
  );
}

export default Home;